<div *ngIf="faqs?.length" class="seo-faq-wrapper">
    <h2 class="heading">{{ heading }}</h2>
    <p class="text">{{ text }}</p>
    <div [class.accordions-wrapper]="banner">
        <div [class.accordions]="banner">
            <ng-container *ngFor="let faq of faqs; let i = index;">
                <div class="faq-accordion" [class.white-background-mobile]="setMobileWhiteBackground"
                    [class.white-background-desktop]="setDesktopWhiteBackground">
                    <div class="faq-header">
                        <h3 class="question">{{ faq.question }}</h3>
                        <img (click)="toggleFaqAnswer(i, 'open')" alt="plus-icon" [id]="'toggle-open-' + i"
                            class="toggle-icon" src="../../../../assets/icons/accordion-plus.svg">
                        <img (click)="toggleFaqAnswer(i, 'hide')" alt="minus-icon" [id]="'toggle-hide-' + i"
                            class="toggle-icon hidden" src="../../../../assets/icons/accordion-minus.svg">
                    </div>
                    <div class="answer" [id]="'faq-answer-' + i" [innerHTML]="faq.answer | safeHTML"></div>
                </div>
            </ng-container>
        </div>
        <div class="banner" *ngIf="banner">
            <a [href]="banner.redirectTo">
                <picture class="banner-picture">
                    <source [srcset]="bannerImages + banner.img + '.webp'" type="image/webp">
                    <img bz-image [src]="bannerImages + 'png/' + banner.img + '.png'" [title]="'Банер'" [alt]="'Банер'">
                </picture>
            </a>
        </div>
    </div>
    <p class="text" *ngIf="footer">{{ footer }}</p>
</div>